
import Vue from 'vue';
import Gleap from 'gleap';
import CommonMixin from '@/mixins/CommonMixin';
import FormMixin from '@/components/Common/Mixins/FormMixin';
import { handleErrorUI } from '../util/error';
import { validateMandatoryFields, empty } from '@/util/validation';
import store from '@/store';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import users from '@/services/users.js';
import Notifications from '@/components/Notifications.vue';
export default {
  components: { Notifications },
  mixins: [CommonMixin, FormMixin],
  data() {
    return {
      notificationSettings: {
        notifyKpiReportWeekly: false,
        notifyKpiReportMonthly: false
      },
      tabs: 'profile',
      data: {},
      isStoreMulti: true,
      jobRole: null,
      store: null,
      needStore: false,
      changePassword: true,
      loading: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      imageURL: null,
      imgCheck: true,
      photo: '',
      photoFormat: '',
      canUserChangePassword: true,
      storeOptions: [],
      showStoreSelect: true,
      storesSelected: []
    };
  },
  computed: {
    ...mapGetters('store', ['getAllStoreInfo']),
    ...mapState('store', { storeStores: 'stores' }),
    ...mapGetters('user', ['getLocale']),

    jobRoleOptions() {
      return [
        {
          label: this.$store.state.user.translateWhole.survey_option1[
            this?.getLocale
          ],
          value: 'Store Employee',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option2[
            this?.getLocale
          ],
          value: 'Store Manager or Assistant Store Manager',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option3[
            this?.getLocale
          ],
          value: 'Area Manager',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option4[
            this?.getLocale
          ],
          value: 'Visual Merchandiser (VMD)',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option5[
            this?.getLocale
          ],
          value: 'Head Office - Marketing',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option6[
            this?.getLocale
          ],
          value: 'Head Office - Sales',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option7[
            this?.getLocale
          ],
          value: 'Head Office - IT or Operations (Admin)',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option8[
            this?.getLocale
          ],
          value: 'Head Office - Corporate Management',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option9[
            this?.getLocale
          ],
          value: 'Head Office - Human Resources & General Affairs Dept',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option10[
            this?.getLocale
          ],
          value: 'Head Office - Other',
          needStore: true
        },
        {
          label: this.$store.state.user.translateWhole.survey_option11[
            this?.getLocale
          ],
          value: 'Other, not listed above',
          needStore: true
        }
      ];
    }
  },
  watch: {
    'data.jobRole': async function(newRole) {
      const selectedRole = this.jobRoleOptions.find(r => r.value === newRole);
      if (!selectedRole) return;
      this.storesSelected = [];
      this.needStore = selectedRole.needStore;
      this.isStoreMulti = !(
        selectedRole.value == 'Store Employee' ||
        selectedRole.value == 'Store Manager or Assistant Store Manager'
      );
      // this.storeOptions = await this.fetchStores();
    },
    photo(newVal) {
      this.imgCheck = !newVal;
    },
    imageURL(newVal) {
      this.imgCheck = !newVal;
    }
  },
  async created() {
    try {
      this.data = await this.getProfile();
      this.notificationSettings = {
        notifyKpiReportWeekly: !!this.data.notifyKpiReportWeekly,
        notifyKpiReportMonthly: !!this.data.notifyKpiReportMonthly
      };
      const resp = await users.getUserLocations(this.selectedUser?._id);
      const res = resp?.data?.response?.myStores;
      //
      if (res) {
        this.storesSelected = this.isStoreMulti
          ? res.map(i => i.storeNumber)
          : res.map(i => i.storeNumber)[0];
      }
      //
      const selectedRole = this.jobRoleOptions.find(
        r => r.value === this.data.jobRole
      );
      this.needStore = selectedRole?.needStore || false;
      this.data.store = Array.isArray(this.data.store)
        ? this.data.store[0] || ''
        : this.data.store || '';
      this.storeOptions = await this.fetchStores();
      await this.fetchProfilePicture();
    } catch (err) {
      handleErrorUI(err);
    }
  },
  mounted() {
    this.canUserChangePassword = localStorage.getItem('islogin_sso') == null;
    this.fetchProfilePicture();
  },
  methods: {
    ...mapGetters('user', ['getProfile']),
    ...mapMutations('user', ['setProfile']),
    ...mapActions('user', [
      'updateProfileSSO',
      'changePasswordSSO',
      'userDetailHandler'
    ]),
    async saveNotificationSettings({
      notifyKpiReportWeekly,
      notifyKpiReportMonthly
    }: {
      notifyKpiReportWeekly: boolean;
      notifyKpiReportMonthly: boolean;
    }) {
      const payload = {
        notifyKpiReportWeekly,
        notifyKpiReportMonthly
      };

      try {
        await this.updateProfileSSO(payload);

        // refresh local user data only AFTER success
        await this.userDetailHandler();
        this.setProfile({ profile: this.data });

        this.$q.notify({
          type: 'positive',
          position: 'top',
          message: this.$t('AuthPage.user_details_changed_successfully')
        });
      } catch (error) {
        handleErrorUI(error);
      }
    },
    // --- Mixpanel persistent user attribute ---
    setMixpanelUserProfile(profile, jobRole) {
      if (!Vue.prototype.$mixpanel) return;
      Vue.prototype.$mixpanel.people.set({
        job_role: jobRole,
        email: profile?.email
      });
    },

    // --- Mixpanel contextual event ---
    trackMixpanelEvent(eventName, jobRole) {
      if (!Vue.prototype.$mixpanel) return;
      Vue.prototype.$mixpanel.track(eventName, {
        job_role: jobRole,
        source: 'Profile Update'
      });
    },

    // --- Gleap user segmentation (package version) ---
    setGleapUserProfile(profile, jobRole) {
      if (!Gleap) return;
      Gleap.identify(profile?._id || profile?.email, {
        name: `${profile?.firstName || ''} ${profile?.lastName || ''}`,
        email: profile?.email,
        customData: {
          job_role: jobRole
        }
      });
    },

    checkFullwidth(v) {
      // eslint-disable-next-line no-useless-escape
      return /^[ A-Za-z0-9_@./~`#&+,:;=<>%$*|!^{}\[\]()?'"\\-]*$/.test(v);
    },
    checkSpecialSymbols(v) {
      // eslint-disable-next-line no-useless-escape
      return /^(?=.*[_@./~`#&+,:;=<>%$*|!^{}\[\]()?'"\\-]).{1,}$/.test(v);
    },
    async saveChanges() {
      this.loading = true;
      try {
        await this.uploadFile(this.photo, this.photoFormat);
        const payload = { ...this.data };
        // new code
        var locations = [];
        if (this.data.jobRole && this.storesSelected) {
          payload.role = this.data.jobRole;
          locations = [
            {
              type: 'mystores',
              storeCodes: this.isStoreMulti
                ? this.storesSelected.map(item => item)
                : [this.storesSelected]
            }
          ];
        }
        let UsrDetails = {
          userId: this.data._id,
          locations
        };
        await users.setUserLocations(UsrDetails);
        // new code
        await this.updateProfileSSO(payload);
        this.userDetailHandler();
        this.setProfile({ profile: this.data });
        this.setMixpanelUserProfile(this.data, this.data.jobRole);
        this.trackMixpanelEvent('User Profile Updated', this.data.jobRole);
        this.setGleapUserProfile(this.data, this.data.jobRole);
        this.$q.notify({
          type: 'positive',
          position: 'top',
          message: this.$t('AuthPage.user_details_changed_successfully')
        });
        setTimeout(() => window.location.reload(), 1000);
      } catch (err) {
        handleErrorUI(err);
      } finally {
        this.loading = false;
      }
    },
    async submitPasswordChange() {
      if (this.newPassword !== this.confirmPassword) {
        throw new Error("Confirmation password doesn't match");
      }
      try {
        this.loading = true;
        await this.changePasswordSSO({
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          newConfirmPassword: this.confirmPassword
        });
        this.$q.notify({
          position: 'top',
          message: this.$t('AuthPage.password_changed_successfully'),
          type: 'positive'
        });
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.accountForm.reset();
      } catch (err) {
        if (err.message === 'Invalid old password') {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            message: this.$t('AuthPage.invalid_old_password')
          });
        } else {
          handleErrorUI(err);
        }
      } finally {
        this.loading = false;
      }
    },
    handleFileUpload(event) {
      const files = event.target.files;
      for (const file of files) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.photo = reader.result;
          this.photoFormat = file.type.split('/')[1];
        };
        reader.readAsDataURL(file);
      }
    },
    async uploadFile(file, format) {
      if (!file || !format) return;
      const base64Data = file.replace(`data:image/${format};base64,`, '');
      await this.$repo.user.updateProfilePicture(base64Data, format);
      await this.fetchProfilePicture();
    },
    async fetchProfilePicture() {
      try {
        const response = await this.$repo.user.getProfilePicture();
        this.imageURL =
          response || this.$store.state.user.profile.photo || null;
        this.imgCheck = !this.imageURL;
      } catch (err) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: 'Failed to retrieve the profile picture'
        });
      }
    },
    async fetchStores() {
      const codeNameList = store.getters['user/getStoresCodeNameList'];
      return codeNameList.map(st => ({
        label: `${st.storeCode} ${st.name}`,
        value: st.storeCode,
        storeName: st.name,
        storeCode: st.storeCode
      }));
    }
  }
};
